const runtimeConfig = window.RUNTIME_CONFIG || {};

let config;

if (process.env.REACT_APP_PRODUCTION === "1") {
  config = runtimeConfig;
} else {
  config = {
    REACT_APP_SECRET_API: process.env.REACT_APP_SECRET_API,
    REACT_APP_IMS_API: process.env.REACT_APP_IMS_API,
    REACT_APP_LOGIN: process.env.REACT_APP_LOGIN,
    REACT_APP_SECRET_DOMAIN: process.env.REACT_APP_SECRET_DOMAIN,
    REACT_APP_GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY,
    REACT_APP_DEM_WIDGET_URL: process.env.REACT_APP_DEM_WIDGET_URL,
    REACT_APP_INSTALLER_URL: process.env.REACT_APP_INSTALLER_URL,
  };
}

export default config;
